export default __webpack_public_path__ + "static/checknlearn-promo@2x-d066d0945af37a38d1b11600bef125bb.webp";